import { backendClient } from '../lib/api/backendClient';

export type ImportOnboardingSettingValue = {
  version?: number;
  seenAt?: string | null;
  dismissedAt?: string | null;
};

const IMPORT_ONBOARDING_KEY = 'importOnboarding';
const IMPORT_ONBOARDING_VERSION = 1;

const normalize = (raw: unknown): ImportOnboardingSettingValue => {
  if (!raw || typeof raw !== 'object') return { version: IMPORT_ONBOARDING_VERSION, seenAt: null };
  const value = raw as ImportOnboardingSettingValue;
  const seenAt =
    typeof value.seenAt === 'string' && value.seenAt.trim().length ? value.seenAt.trim() : null;
  const dismissedAt =
    typeof value.dismissedAt === 'string' && value.dismissedAt.trim().length
      ? value.dismissedAt.trim()
      : null;

  const version =
    typeof value.version === 'number' && Number.isFinite(value.version)
      ? value.version
      : IMPORT_ONBOARDING_VERSION;

  return { version, seenAt, dismissedAt };
};

export const importOnboardingSettingsService = {
  async fetch(): Promise<ImportOnboardingSettingValue> {
    try {
      const { data } = await backendClient.get<{ setting?: { value?: ImportOnboardingSettingValue } }>(
        `/favorites/settings/${IMPORT_ONBOARDING_KEY}`
      );
      return normalize(data?.setting?.value);
    } catch (error: any) {
      if (error?.response?.status === 404) {
        return { version: IMPORT_ONBOARDING_VERSION, seenAt: null };
      }
      throw error;
    }
  },

  async markSeen(payload: { version?: number; seenAt: string }) {
    const version =
      typeof payload.version === 'number' && Number.isFinite(payload.version)
        ? payload.version
        : IMPORT_ONBOARDING_VERSION;
    await backendClient.put(`/favorites/settings/${IMPORT_ONBOARDING_KEY}`, {
      value: { version, seenAt: payload.seenAt },
    });
  },
};
